import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import { InstantSearch, Configure, useInstantSearch } from 'react-instantsearch';
import { ReviewsResults } from '../../commons/helpers';
const SearchSectionCountTracker = t0 => {
  const $ = _c(6);
  const {
    onCountChange
  } = t0;
  const {
    results
  } = useInstantSearch();
  let t1;
  if ($[0] !== onCountChange || $[1] !== results?.nbHits) {
    t1 = () => {
      const count = results?.nbHits;
      if (typeof onCountChange === "function" && Number.isFinite(count)) {
        onCountChange(count);
      }
    };
    $[0] = onCountChange;
    $[1] = results?.nbHits;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = results?.nbHits;
  let t3;
  if ($[3] !== onCountChange || $[4] !== t2) {
    t3 = [t2, onCountChange];
    $[3] = onCountChange;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t1, t3);
  return null;
};
const SearchReviewsContent = t0 => {
  const $ = _c(14);
  const {
    indexName,
    searchClient,
    searchState,
    searchStateQuery,
    updateSearchPage,
    onSectionCountChange
  } = t0;
  let t1;
  if ($[0] !== searchState.configure.facetFilters || $[1] !== searchStateQuery) {
    t1 = <Configure query={searchStateQuery} hitsPerPage={9} facetFilters={searchState.configure.facetFilters} />;
    $[0] = searchState.configure.facetFilters;
    $[1] = searchStateQuery;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onSectionCountChange) {
    t2 = <SearchSectionCountTracker onCountChange={onSectionCountChange} />;
    $[3] = onSectionCountChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== updateSearchPage) {
    t3 = <ReviewsResults onLoadMore={updateSearchPage} variant="advanced-search" />;
    $[5] = updateSearchPage;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== indexName || $[8] !== searchClient || $[9] !== searchState || $[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = <div className="w-full"><InstantSearch searchClient={searchClient} searchState={searchState} indexName={indexName}>{t1}{t2}{t3}</InstantSearch></div>;
    $[7] = indexName;
    $[8] = searchClient;
    $[9] = searchState;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
export default SearchReviewsContent;